// extracted by mini-css-extract-plugin
export default {"card":"style_card__USNtr","text":"style_text__Nft3K","button":"style_button__VQF4q"};